import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { Hero } from "@/components/site/Hero";
import { PageShell } from "@/components/site/PageShell";
import { breadcrumbLd } from "@/lib/jsonld";
import { SITE } from "@/lib/site";

const crumbs = [{ label: "Datenschutz", to: "/datenschutz" }];
const MAIL_SENDER = "info@kfzsv-marcone.de";

export default function DatenschutzPage() {
  return (
    <>
      <Seo title="Datenschutzerklärung | Kfz-Sachverständiger Marcone" description="Datenschutzerklärung des Kfz-Sachverständigen Marcone in Köln: Hosting, Anfrageformulare, Foto-Upload, E-Mail, WhatsApp, Karte, Speicherdauer und Ihre Rechte nach DSGVO." path="/datenschutz" jsonLd={[breadcrumbLd(crumbs)]} />
      <PageShell hero={<Hero image="hero-leasing" imageAlt="Fahrzeug in einem hellen Autohaus" title="Datenschutzerklärung" breadcrumbs={crumbs} badges={false} />}>
        <article className="legal-content" data-testid="privacy-content">
          <p style={{ marginTop: 0 }}>
            Der Schutz Ihrer persönlichen Daten ist uns wichtig. Nachfolgend informieren wir Sie gemäß Art. 13 und 14 der Datenschutz-Grundverordnung (DSGVO), welche
            personenbezogenen Daten wir beim Besuch dieser Website und bei einer Anfrage verarbeiten, zu welchem Zweck und welche Rechte Sie haben.
          </p>

          <h2>1. Verantwortlicher</h2>
          <p data-testid="privacy-controller">
            {SITE.company} – Kfz-Sachverständigenbüro Marcone<br />
            {SITE.owner}<br />
            {SITE.street}, {SITE.zip} {SITE.city}<br />
            Telefon: <a href={SITE.phoneHref}>{SITE.phoneIntl}</a><br />
            E-Mail: <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
          </p>
          <p>Ein Datenschutzbeauftragter ist nicht benannt, da hierzu keine gesetzliche Pflicht besteht. Wenden Sie sich bei Fragen zum Datenschutz bitte direkt an uns.</p>

          <h2>2. Überblick und Rechtsgrundlagen</h2>
          <p>Wir verarbeiten personenbezogene Daten nur, soweit dies für den Betrieb dieser Website und die Bearbeitung Ihrer Anfragen erforderlich ist. Rechtsgrundlagen sind:</p>
          <ul>
            <li>Art. 6 Abs. 1 lit. a DSGVO – Ihre Einwilligung (z. B. beim Absenden eines Formulars, beim Laden der Karte)</li>
            <li>Art. 6 Abs. 1 lit. b DSGVO – Vertrag oder vorvertragliche Maßnahmen (z. B. Bearbeitung Ihrer Gutachtenanfrage)</li>
            <li>Art. 6 Abs. 1 lit. c DSGVO – rechtliche Verpflichtung (z. B. steuer- und handelsrechtliche Aufbewahrungspflichten)</li>
            <li>Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse (z. B. sicherer Betrieb der Website, Schutz vor Missbrauch)</li>
          </ul>

          <h2>3. Hosting und Server-Logfiles</h2>
          <p>
            Diese Website wird bei der IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, Deutschland, gehostet. IONOS verarbeitet die Daten ausschließlich in unserem
            Auftrag und nach unseren Weisungen; mit IONOS besteht ein Vertrag zur Auftragsverarbeitung nach Art. 28 DSGVO.
          </p>
          <p>
            Beim Aufruf der Website werden automatisch technisch notwendige Daten in Server-Logfiles verarbeitet: IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite,
            übertragene Datenmenge, Referrer-URL, Browsertyp und Betriebssystem. Dies ist erforderlich, um die Website auszuliefern sowie Stabilität und Sicherheit zu
            gewährleisten (Art. 6 Abs. 1 lit. f DSGVO). Die Logfiles werden nur für einen begrenzten Zeitraum gespeichert und anschließend gelöscht, sofern sie nicht zur
            Aufklärung eines konkreten Sicherheitsvorfalls benötigt werden. Eine Zusammenführung mit anderen Datenquellen findet nicht statt.
          </p>

          <h2>4. SSL-/TLS-Verschlüsselung</h2>
          <p>
            Diese Website nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung, erkennbar am Schloss-Symbol und an „https://“ in der Adresszeile. Daten, die Sie an uns
            übermitteln – etwa über die Formulare – können dadurch nicht von Dritten mitgelesen werden.
          </p>

          <h2>5. Anfrageformulare (Rückruf, E-Mail-Anfrage, Schaden melden)</h2>
          <p>Wenn Sie uns über ein Formular kontaktieren, verarbeiten wir die von Ihnen eingegebenen Daten:</p>
          <ul>
            <li><strong>Rückruf:</strong> Name, Telefonnummer, Wunschzeit bzw. Rückruftermin, Anliegen</li>
            <li><strong>E-Mail-Anfrage:</strong> Name, E-Mail-Adresse, optional Telefonnummer und gewünschte Leistung, Ihre Nachricht</li>
            <li><strong>Schaden melden:</strong> Name, Telefonnummer, E-Mail-Adresse, Schadenursache, PLZ, optional Kennzeichen, Unfalldatum, Fahrbereitschaft, gegnerische Versicherung, Nachricht und Fotos</li>
          </ul>
          <p>
            Zweck ist die Bearbeitung Ihrer Anfrage und die Kontaktaufnahme mit Ihnen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) sowie Ihre
            Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO, die Sie mit dem Häkchen im Formular erteilen. Die Einwilligung können Sie jederzeit mit Wirkung für die Zukunft
            widerrufen, z. B. per E-Mail an <a href={`mailto:${SITE.email}`}>{SITE.email}</a>.
          </p>
          <p>
            Zusätzlich speichern wir den Zeitpunkt der Anfrage und der Einwilligung, die Seite, von der die Anfrage gesendet wurde, die Einstiegsseite, die verweisende Seite
            (Referrer) sowie ggf. in der Adresszeile enthaltene Kampagnenparameter (utm-Parameter, gclid). So können wir nachvollziehen, wie Sie auf uns aufmerksam geworden
            sind (Art. 6 Abs. 1 lit. f DSGVO). Hierfür werden keine Cookies gesetzt und keine Daten im Browser gespeichert.
          </p>
          <p>
            Die Formulardaten werden in einer geschützten Datenbank unseres Hosters gespeichert und sind nur für uns in einem passwortgeschützten Admin-Bereich einsehbar.
          </p>

          <h3>Foto-Upload</h3>
          <p>
            Beim Formular „Schaden melden“ können Sie bis zu 10 Fotos hochladen. Die Fotos werden verschlüsselt übertragen und bei einem Cloud-Speicherdienstleister als
            Auftragsverarbeiter (Art. 28 DSGVO) gespeichert. Sie sind ausschließlich für uns im geschützten Admin-Bereich abrufbar. 180 Tage nach Eingang werden die Fotos
            automatisch gesperrt und sind danach nicht mehr abrufbar. Bitte laden Sie nur Fotos hoch, die für die Schadenbeurteilung nötig sind, und vermeiden Sie
            möglichst die Abbildung unbeteiligter Personen.
          </p>

          <h3>Spam-Schutz</h3>
          <p>
            Zum Schutz vor missbräuchlichen Anfragen verwenden wir ein für Menschen unsichtbares Prüffeld und begrenzen die Anzahl der Anfragen pro IP-Adresse. Die IP-Adresse
            wird dafür für maximal 10 Minuten gespeichert (Art. 6 Abs. 1 lit. f DSGVO). Ein externer Captcha-Dienst wird nicht eingesetzt.
          </p>

          <h2>6. E-Mail-Benachrichtigung und Eingangsbestätigung</h2>
          <p>
            Nach dem Absenden eines Formulars erhalten wir eine Benachrichtigung mit Ihren Angaben per E-Mail. Haben Sie eine E-Mail-Adresse angegeben, senden wir Ihnen
            außerdem eine automatische Eingangsbestätigung mit Ihrer Vorgangsnummer (Art. 6 Abs. 1 lit. b DSGVO). Fotos werden nicht per E-Mail versendet.
          </p>
          <p>
            Für den Versand und Empfang von E-Mails nutzen wir den E-Mail-Dienst der IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, als Auftragsverarbeiter (Absender:{" "}
            {MAIL_SENDER}). Die Übertragung erfolgt transportverschlüsselt (TLS). Wenn Sie uns direkt per E-Mail schreiben, verarbeiten wir Ihre E-Mail-Adresse und den Inhalt
            Ihrer Nachricht zur Bearbeitung Ihres Anliegens.
          </p>

          <h2>7. Kontakt per Telefon und WhatsApp</h2>
          <p>
            Wenn Sie uns anrufen, verarbeiten wir Ihre Telefonnummer und Ihre Angaben zur Bearbeitung Ihres Anliegens (Art. 6 Abs. 1 lit. b bzw. f DSGVO).
          </p>
          <p>
            Der WhatsApp-Button auf dieser Website ist ein einfacher Link. Erst wenn Sie ihn anklicken, wird WhatsApp geöffnet und eine Verbindung zu WhatsApp Ireland Ltd.,
            Merrion Road, Dublin 4, D04 X2K5, Irland, hergestellt. Für die Kommunikation über WhatsApp gelten die Datenschutzbestimmungen von WhatsApp; eine Übermittlung von
            Daten an die Muttergesellschaft Meta Platforms Inc. in den USA ist möglich. Meta ist unter dem EU-U.S. Data Privacy Framework zertifiziert (Angemessenheitsbeschluss
            der EU-Kommission). Die Nutzung von WhatsApp ist freiwillig – Sie können uns jederzeit auch per Telefon, E-Mail oder Formular erreichen.
          </p>

          <h2>8. Kartendienst OpenStreetMap</h2>
          <p>
            Auf der Kontaktseite können Sie eine Karte von OpenStreetMap (OpenStreetMap Foundation, St John’s Innovation Centre, Cowley Road, Cambridge, CB4 0WS,
            Vereinigtes Königreich) laden. Die Karte wird erst nach Ihrem Klick geladen; dabei wird Ihre IP-Adresse an die Server von OpenStreetMap übertragen
            (Art. 6 Abs. 1 lit. a DSGVO). Für das Vereinigte Königreich besteht ein Angemessenheitsbeschluss der EU-Kommission. Ohne Ihren Klick findet keine Verbindung statt.
          </p>

          <h2>9. Schriftarten</h2>
          <p>Die verwendete Schrift „Open Sans“ ist lokal auf unserem Server eingebunden. Eine Verbindung zu Servern von Google oder anderen Drittanbietern findet dabei nicht statt.</p>

          <h2>10. Cookies, Tracking und Analyse</h2>
          <p>
            Diese Website setzt keine Tracking-, Analyse- oder Marketing-Cookies und verwendet keine Analyse- oder Werbedienste (z. B. Google Analytics, Google Ads,
            Meta-Pixel). Deshalb ist auch kein Cookie-Banner erforderlich. Lediglich im passwortgeschützten Admin-Bereich werden technisch notwendige Sitzungs-Cookies
            für die Anmeldung verwendet (§ 25 Abs. 2 Nr. 2 TDDDG). Sollten wir künftig Analyse- oder Marketingdienste einsetzen, holen wir vorher Ihre Einwilligung ein
            und passen diese Datenschutzerklärung an.
          </p>

          <h2>11. Empfänger Ihrer Daten</h2>
          <p>Ihre Daten geben wir nur weiter, soweit dies zur Bearbeitung Ihrer Anfrage bzw. zur Erfüllung des Gutachtenauftrags erforderlich ist oder Sie eingewilligt haben:</p>
          <ul>
            <li>technische Dienstleister als Auftragsverarbeiter (Hosting und E-Mail: IONOS SE; Cloud-Speicher für Fotos)</li>
            <li>im Rahmen eines Auftrags: die {SITE.company} als Partnerunternehmen, Versicherungen (insbesondere die Haftpflichtversicherung des Unfallgegners), Ihr Rechtsanwalt oder Ihre Werkstatt – nur soweit für die Gutachtenerstellung und Schadenregulierung erforderlich oder von Ihnen gewünscht</li>
            <li>bei Totalschäden ggf. Restwertanbieter, wobei nur fahrzeugbezogene Daten übermittelt werden</li>
            <li>Behörden und Gerichte, soweit wir gesetzlich dazu verpflichtet sind</li>
          </ul>
          <p>Eine Weitergabe zu Werbezwecken oder ein Verkauf Ihrer Daten findet nicht statt.</p>

          <h2>12. Übermittlung in Drittländer</h2>
          <p>
            Eine Übermittlung Ihrer Daten in Länder außerhalb der EU bzw. des EWR ist von uns nicht vorgesehen. Ausnahmen bestehen nur, wenn Sie selbst WhatsApp nutzen
            (siehe Ziffer 7) oder die Karte laden (siehe Ziffer 8).
          </p>

          <h2>13. Speicherdauer</h2>
          <p>
            Wir speichern personenbezogene Daten nur so lange, wie es für den jeweiligen Zweck erforderlich ist. Anfragen, aus denen kein Auftrag entsteht, löschen wir,
            sobald die Bearbeitung abgeschlossen ist und keine Rückfragen mehr zu erwarten sind. Kommt ein Auftrag zustande, speichern wir die Daten für die Dauer der
            Auftragsabwicklung und darüber hinaus im Rahmen der gesetzlichen Aufbewahrungsfristen (bis zu 6 bzw. 10 Jahre nach § 257 HGB und § 147 AO) sowie bis zum Ablauf
            möglicher Verjährungsfristen. Hochgeladene Fotos werden nach 180 Tagen gesperrt. Nach einem Widerruf Ihrer Einwilligung löschen wir die betroffenen Daten,
            soweit keine andere Rechtsgrundlage oder Aufbewahrungspflicht besteht.
          </p>

          <h2>14. Pflicht zur Bereitstellung, keine automatisierte Entscheidung</h2>
          <p>
            Sie sind weder gesetzlich noch vertraglich verpflichtet, uns Daten bereitzustellen. Ohne die als Pflichtfelder gekennzeichneten Angaben können wir Ihre Anfrage
            jedoch nicht bearbeiten. Eine automatisierte Entscheidungsfindung einschließlich Profiling (Art. 22 DSGVO) findet nicht statt.
          </p>

          <h2>15. Ihre Rechte</h2>
          <p>Sie haben jederzeit das Recht auf:</p>
          <ul data-testid="privacy-rights">
            <li>Auskunft über Ihre bei uns gespeicherten Daten (Art. 15 DSGVO)</li>
            <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
            <li>Löschung (Art. 17 DSGVO) und Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
          </ul>
          <p>Wenden Sie sich dazu einfach formlos an <a href={`mailto:${SITE.email}`}>{SITE.email}</a> oder telefonisch an <a href={SITE.phoneHref}>{SITE.phoneIntl}</a>.</p>

          <div className="my-6 rounded-xl bg-brand-sky-light p-5 ring-1 ring-brand-blue/20" data-testid="privacy-objection">
            <h3 style={{ marginTop: 0 }}>Widerspruchsrecht nach Art. 21 DSGVO</h3>
            <p style={{ marginBottom: 0 }}>
              Soweit wir Ihre Daten auf Grundlage eines berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO) verarbeiten, können Sie aus Gründen, die sich aus Ihrer
              besonderen Situation ergeben, jederzeit Widerspruch gegen diese Verarbeitung einlegen. Wir verarbeiten die Daten dann nicht mehr, es sei denn, wir können
              zwingende schutzwürdige Gründe nachweisen oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
            </p>
          </div>

          <h2>16. Beschwerderecht bei einer Aufsichtsbehörde</h2>
          <p>
            Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren (Art. 77 DSGVO). Für uns zuständig ist: Landesbeauftragte für Datenschutz und
            Informationsfreiheit Nordrhein-Westfalen, Kavalleriestraße 2–4, 40213 Düsseldorf,{" "}
            <a href="https://www.ldi.nrw.de" target="_blank" rel="noopener noreferrer">www.ldi.nrw.de</a>.
          </p>

          <h2>17. Aktualität dieser Datenschutzerklärung</h2>
          <p>
            Wir passen diese Datenschutzerklärung an, wenn sich unsere Website oder die rechtlichen Vorgaben ändern. Es gilt die jeweils hier veröffentlichte Fassung.
            Weitere Angaben zum Anbieter finden Sie im <Link to="/impressum" data-testid="privacy-impressum-link">Impressum</Link>.
          </p>
          <p data-testid="privacy-date">Stand: Juni 2026</p>
        </article>
      </PageShell>
    </>
  );
}
